import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Tooltip } from 'primereact/tooltip';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Sidebar } from 'primereact/sidebar';
import BasicDock from './BasicDock';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import SidebarViewEmpresa from './SidebarViewEmpresa';
import FormNovaEmpresa from './FormNovaEmpresa';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEngrenagem from '../../../Componentes/BotaoEngrenagem';
import { SpeedDial } from 'primereact/speeddial';



export default function Empresas(props) {
    const toast = React.useRef(null); // Ref para o Toast

    
    const [loading, setLoading] = useState(false);

    const [empresas, setEmpresas] = useState([]);

    const [visible, setVisible] = useState(false);

    const [verInativos, setVerInativos]= useState(false);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idempresa: { value: '', matchMode: FilterMatchMode.CONTAINS },
        cpf_cnpj: { value: '', matchMode: FilterMatchMode.EQUALS },
        razaosocial: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        cidade: { value: '', matchMode: FilterMatchMode.CONTAINS },
        estado: { value: '', matchMode: FilterMatchMode.EQUALS },
        ativo: { value: 't', matchMode: FilterMatchMode.EQUALS }
    });

   
    useEffect(() => {

        setFilters(prevFilters => ({
            ...prevFilters,
            ativo: verInativos ? { value: null, matchMode: FilterMatchMode.EQUALS } : { value: 't', matchMode: FilterMatchMode.EQUALS }
        }));

    }, [verInativos]);



    const [empresa, setEmpresa]= useState([]);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const [overlayVisible, setOverlayVisible] = useState(false);

    const op = useRef(null); // Referência para o OverlayPanel

    const overlayBtn = useRef(null); // Referência para o botão de filtro

    const firstGet = useRef(false)
   
       useEffect(() => {
           if(!firstGet.current){
               firstGet.current = true
               getData();
           }
       }, []);

    const getData = () => {
       
        clearFilters(verInativos)

        setLoading(true);

        Conexao.post('empresasController/getEmpresas?idempresa=' + dataEmpresa.idrevenda, { filtro: "todos", tipoFiltro: "", ativo : "todos" })
        .then(response => {

            if (response.status === 200 && response.data.status === 'OK') {

                setEmpresas(response.data.payload);

                setLoading(false);

            } else {
                setEmpresas([])
                setLoading(false);
                showMessageToast('warn', "Não foi possível recuperar dados")
            }

        }).catch(error => {
            setEmpresas([])
            setLoading(false);
            showMessageToast('error', "erro ao recuperar dados")
        });
    };

    

    const handleFilterChange = (e, field) => {

        const value = e.target.value;
        
        setFilters(prevFilters => ({
            ...prevFilters,
            [field]: { value, matchMode: FilterMatchMode.CONTAINS },
        }));
    };

    const handleFilterConfirm = () => {
        // Aqui você pode aplicar os filtros ao DataTable ou fazer outras ações necessárias
        setOverlayVisible(false); // Fecha o overlay após aplicar os filtros
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
    
        // Atualizar o filtro global
        const _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
    
        // Identificar os campos onde o filtro foi encontrado
        const foundFields = [];
    
        // Verificando em cada campo se o filtro global está presente
        const fields = ['idempresa', 'cpf_cnpj', 'razaosocial', 'cidade', 'estado'];
        fields.forEach(field => {
            const fieldValue = empresas.map(empresa => empresa[field]?.toString().toLowerCase());
            const matches = fieldValue.some(val => val.includes(value.toLowerCase()));
            if (matches) {
                foundFields.push(field); // Adiciona o campo encontrado
            }
        });
    
        setFieldsFound(foundFields); // Atualiza o estado com os campos encontrados
    };
    
    
    
    const renderBotaoEditar = (row, opcao) => {
  
        return (
            <Button 
                icon="pi pi-pencil"
                onClick={() => {
                    console.log("Opções para:", row)
                    setEmpresa(row)
                }} 
                disabled={loading}
                tooltip="Editar dados da empresa" tooltipOptions={{ position: 'left' }}
            />
        );
    };

    const renderBotaoDataclassic= (row, opcao) => {
  
        return (
            <BotaoEngrenagem                 
                onClick={() => {
                    console.log("Opções para:", row)
                    setEmpresa(row)
                }} 
                disabled={loading}              
                tooltip="Alterar configurações da integração com o Dataclassic" tooltipOptions={{ position: 'left' }}
            />
        );
    };
    const renderStatusRow= (row, opcao) => {

        return (
            row.ativo =='t' ? <><Tooltip target=".tagAtiva-tooltip" content="Esta Empresa esta ATIVA" position="top" />
                                <Tag className='tagAtiva-tooltip' severity="success" value="ATIVO" style={{cursor :'pointer'}} onClick={()=>{
                if(row.padrao === 't' || empresas.length === 1){
                    showMessageToast('warn', 'Você não pode desativar uma empresa padrão!');
                    return;
                }
                updateStatusEmpresa(row.idempresa, row.ativo)
            }} ></Tag></> : <><Tooltip target=".tagIntiva-tooltip" content="Esta Empresa esta INATIVA" position="top" />
            <Tag className='tagIntiva' severity="danger" value="INATIVO" style={{cursor :'pointer'}} onClick={()=>{
                if(row.padrao === 't' || empresas.length === 1){
                    showMessageToast('warn', 'Você não pode desativar uma empresa padrão!');
                    return;
                }
                updateStatusEmpresa(row.idempresa, row.ativo)
            }}></Tag></>
        );
    };

    const updateStatusEmpresa = (idempresa, status) =>{
        confirmDialog({
                message: status === 't' ? 'Deseja desabilitar essa empresa?' : 'Deseja ativar essa empresa?',
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sim',
                rejectLabel: 'Não',
                accept: () => {
                    disableEmpresa(idempresa, status)
                } 
            });
    }

    const disableEmpresa = (idempresa, status) => {
    Conexao.get(`empresasController/disableEmpresa?idempresa=${idempresa}&status=${status}`)
        .then(response => {
            if (response.status === 200 && response.data.status === 'OK') {
                showMessageToast('success', 'O status da empresa foi alterado com sucesso!');

                 const updatedEmpresas = empresas.map(item =>
                        item.idempresa === idempresa
                            ? { ...item, ativo: status === 't' ? 'f' : 't' }
                            : item
                    );
                    setEmpresas(updatedEmpresas);

            } else {
                showMessageToast('warn', 'Não foi possível alterar o status da empresa!');
            }
        })
        .catch(error => {
            console.error('Erro ao alterar status da empresa:', error);
            showMessageToast('error', 'Erro ao alterar o status da empresa!');
        });
};


    //empresasController/disableEmpresa?idempresa=77&status=t

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '30px', paddingLeft : '0px'}}>
               
                <div className="flex align-items-center gap-2">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText 
                            value={globalFilterValue} 
                            onChange={onGlobalFilterChange} 
                            placeholder="Pesquisa global" 
                            tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                        />
                    </IconField>
                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-secondary p-button-sm" 
                        onClick={clearFilters} 
                        tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                    />
                    
                    <Button 
                        icon="pi pi-sync" 
                        className= "p-button-primary p-button-sm" 
                        onClick={getData} 
                        tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                    />  

                     <FormNovaEmpresa 
                        idusuario = {dataEmpresa.idrevenda} 
                        Conexao={Conexao}
                        getData = {getData}
                        loading={loading}
                        visible ={visible}
                        setVisible={(op)=>setVisible(op)}
                        setLoading={(op)=>setLoading(op)}/>             
                </div>
                <div className="flex flex-column align-items-start mb-2">
                    <span className="text-small">Inativos</span>
                    <InputSwitch checked={verInativos}
                        onChange={() => {
                            setVerInativos(prev => !prev)
                        }
                            
                        }/>
                </div>
            </div>
        );
    };
    

    const renderFooter = () => {
        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {empresas.length} 
        </div>
        }
        
        return <>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {empresas.length} 
        </div>
        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };

    const clearFilters = (statusAtivo) => {
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idempresa: { value: '', matchMode: FilterMatchMode.CONTAINS },
            cpf_cnpj: { value: '', matchMode: FilterMatchMode.EQUALS },
            razaosocial: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
            cidade: { value: '', matchMode: FilterMatchMode.CONTAINS },
            estado: { value: '', matchMode: FilterMatchMode.EQUALS },
             ativo: statusAtivo ? { value: null, matchMode: FilterMatchMode.EQUALS } : { value: 't', matchMode: FilterMatchMode.EQUALS }
        });
        setFieldsFound([]); // Resetando os campos encontrados
    };



    useEffect(()=>{

    }, [fieldsFound])
    

    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };

    return (
        <Layout loading={loading}>
            <div className="p-2">
              

                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                
                        <DataTable                            
                            header={renderHeader()}  
                            footer={renderFooter} 
                            value={empresas}
                            paginator                 
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '35rem' }}
                            filters={filters} // Aplicando os filtros
                            filterDisplay="menu" // Exibe os filtros como menu pop-up
   
                        >
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody, width : '10%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="idempresa" 
                                header="Código" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                 filterElement={(options) => (
                                        <InputText
                                            value={options.value}                                        
                                            onChange={(e) => options.filterCallback(e.target.value)}
                                            onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                            placeholder=""
                                            />
                                    )}
                                filterPlaceholder="Filtrar Código" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody , width : '15%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="cpf_cnpj" header="CPF/CNPJ" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterElement={(options) => (
                                        <InputText
                                            value={options.value}                                        
                                            onChange={(e) => options.filterCallback(e.target.value)}
                                            onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                            placeholder=""
                                            />
                                    )}
                                filterPlaceholder="Filtrar CPF/CNPJ" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody , width : '40%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="razaosocial" header="Razão Social" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterElement={(options) => (
                                        <InputText
                                            value={options.value}                                        
                                            onChange={(e) => options.filterCallback(e.target.value)}
                                            onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                            placeholder=""
                                            />
                                    )}
                                filterPlaceholder="Filtrar Razão Social" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody , width : '30%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                field="cidade" 
                                header="Cidade" 
                                sortable 
                                filter 
                                filterElement={(options) => (
                                        <InputText
                                            value={options.value}                                        
                                            onChange={(e) => options.filterCallback(e.target.value)}
                                            onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                            placeholder=""
                                            />
                                    )}
                                filterPlaceholder="Filtrar Cidade" />
                            <Column 
                                bodyStyle={{ fontSize: fontConfig.tableBody , width : '10%' }} 
                                headerStyle={{ fontSize: fontConfig.tableHeader }} 
                                field="estado" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                header="UF" 
                                sortable 
                                filter 
                                filterElement={(options) => (
                                        <InputText
                                            value={options.value}                                        
                                            onChange={(e) => options.filterCallback(e.target.value)}
                                            onClick={(e) => e.stopPropagation()} // impede que o sort seja disparado
                                            placeholder=""
                                            />
                                    )}
                                filterPlaceholder="Filtrar UF" />
                            <Column 
                                header="Status" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : renderStatusRow(row)} // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                            />
                            <Column 
                                header="Padrão" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                row.padrao === 't' ? 
                                <Tag severity="success" value="PADRÃO" style={{cursor :'pointer'}} /> : 
                                <><Tooltip target=".tagNaoPadrao-tooltip" content="Clique parar tonar essa a empresa padrão" position="top" />
                                <Tag className='tagNaoPadrao-tooltip' severity="default" value="Não" style={{cursor :'pointer'}} 
                                        onClick={()=>{
                                            confirmDialog({
                                                message: 'Deseja tornar essa a Empresa Padrão?',
                                                header: 'Confirmação',
                                                icon: 'pi pi-exclamation-triangle',
                                                acceptLabel: 'Sim',
                                                rejectLabel: 'Não',
                                                accept: () => {
                                                Conexao.get('empresasController/setarEmpresaAtiva?idusuario='+row.idusuario+'&idempresa='+row.idempresa+'&status=ativo'
                                                    
                                                ).then(response=>{
                                                        if (response.status === 200 && response.data.status === 'OK') {
                                                            showMessageToast('success', 'A empresa padrão foi marcada com sucesso!');

                                                            const updatedEmpresas = empresas.map(item =>
                                                                item.idempresa === row.idempresa
                                                                    ? { ...item, padrao: 't' }
                                                                    : { ...item, padrao: 'f' }
                                                            );
                                                                setEmpresas(updatedEmpresas);

                                                        } else {
                                                            showMessageToast('warn', 'Não foi possível alterar o status da empresa!');
                                                        }
                                                }).catch(error=>{

                                                })
                                                } 
                                            });
                                }}/></>
                            } // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                            />
                            
                            
                            <Column 
                                header="Opções" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : renderBotaoDataclassic(row)} // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                            />
                        </DataTable>
                    
                </div>

                {/* OverlayPanel com campos de filtro */}
                <OverlayPanel ref={op} style={{ width: '300px' }}>
                    <div className="p-3">
                        <h4>Filtros</h4>
                        <div className="p-field">
                            <label htmlFor="idempresa">Código</label>
                            <InputText
                                id="idempresa"
                                value={filters.idempresa.value}
                                onChange={(e) => handleFilterChange(e, 'idempresa')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="razaosocial">Razão Social</label>
                            <InputText
                                id="razaosocial"
                                value={filters.razaosocial.value}
                                onChange={(e) => handleFilterChange(e, 'razaosocial')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="cidade">Cidade</label>
                            <InputText
                                id="cidade"
                                value={filters.cidade.value}
                                onChange={(e) => handleFilterChange(e, 'cidade')}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="estado">UF</label>
                            <InputText
                                id="estado"
                                value={filters.estado.value}
                                onChange={(e) => handleFilterChange(e, 'estado')}
                            />
                        </div>
                        <Button label="Aplicar Filtro" icon="pi pi-check" onClick={handleFilterConfirm} />
                    </div>
                </OverlayPanel>
            </div>
            <SidebarViewEmpresa 
                empresa = {empresa} 
                setEmpresa ={()=>setEmpresa([])}
                idusuario = {dataEmpresa.idrevenda} 
                setDataEmpresas = {(empresa)=>{
                    getData()
                    setEmpresa([])
                }}
                Conexao={Conexao}
                getData = {getData}
                loading={loading}

                setLoading={(op)=>setLoading(op)}
                onHide={() => setEmpresa([])}/>
     
            


                <Toast ref={toast} />

        </Layout>
    );
}
